import Alpine from 'alpinejs'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import { initGalleryCarousel } from './gallery.js'

window.Alpine = Alpine
Alpine.start()

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('[id^="gallery-"]')
  if (gallery) {
    initGalleryCarousel('#' + gallery.id)
  }
})

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

const urlParams = new URLSearchParams(window.location.search)
UTM_KEYS.forEach((key) => {
  const value = urlParams.get(key)
  if (value) {
    sessionStorage.setItem(key, value)
  }
})

const phoneInput = document.querySelector('input[type="tel"][name="phone"]')
if (phoneInput) {
  const iti = intlTelInput(phoneInput, { initialCountry: 'es' })

  const form = phoneInput.closest('form')
  if (form) {
    form.addEventListener('submit', () => {
      const full = iti.getNumber()
      if (full) {
        phoneInput.value = full
      }

      UTM_KEYS.forEach((key) => {
        const value = sessionStorage.getItem(key)
        if (value) {
          const hidden = document.createElement('input')
          hidden.type = 'hidden'
          hidden.name = key
          hidden.value = value
          form.appendChild(hidden)
        }
      })
    })
  }
}
